import { GET_STARTED } from "../pages/redux/constant";
let lastFlag = null;

export const getAuthTNG = (flag, productType) => {
  const tngPayload = {
    api: "getAuthCode",
    scopes: ["auth_base", "auth_user", "USER_INFO_EKYC", "FIN_PROFILE"],
    event: "getAccessToken",
  }

  if(productType) {
    tngPayload.productType = productType;
  }

  if (flag === GET_STARTED) {
    window.my.postMessage(tngPayload);
  } else {
    if (flag !== lastFlag) {
      lastFlag = flag;
      window.my.postMessage(tngPayload);
    }
  }
};
